import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_select_object extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_select_object">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Select (Object)</h2>
              <p>
                Record Select Object allows you to insert data from a source
                record. For example, you may have an “incident” record which you
                want to assign to a client. You would add a select object
                component to the incident record page, which links to the
                “client” object. Select Object does not make a complete copy of
                a record; instead, it will only bring over defined fields. By
                default, these values will not be changed if the original record
                is updated. If this is a requirement, it is possible to manage
                this through a workflow process.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_select_object"}
                name={"select object"}
                dataNameDefault={'"object_my_field"'}
                autoFill={"{ ... }"}
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                sourceUrl={true}
                sourceSave={true}
                onClick={true}
                properties={[
                  {
                    property: "display_secondary",
                    description: "Display the secondary values in barracks.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "allow_clear",
                    description: "Allows user to select a null or no value.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "allow_create",
                    description:
                      "Adds an edit record button in the dialogue window. The button will redirect the user to record edit page. The button will only appear if user has required permissions.To navigate back you will need to create a back button with an onClick function to redirect back to the parent record.",
                    defaults: "true, false default false"
                  },
                  {
                    property: "show_goto",
                    description:
                      "Adds a Goto button that, when a record is selected, allows the user to easily navigate to the foreign record.",
                    defaults: "true, false default false"
                  },

                  {
                    property: "data_mode",
                    description:
                      "Data mode allows you to select between 6 component behaviours.",
                    description2:
                      '"single_object" Allows the user to search a foreign data type and return selected fields to an object field in the current record. Data must be bound to a "object_..." data_name.',
                    description3:
                      '"array_ids" Allows the user to search a foreign data type and select multiple foreign records IDs. Data must be bound to a "array_text_..." data_name.',
                    description4:
                      '"foreign_array_ids" Allows the user to search a foreign data type and edit (add or remove the current records ID) a foreign array_text feild. "array_text_..." data_name in the foerign data type. "foreign_array_ids" will save the changes to the foreign data record at the point of interface change and not wait for the user to click the record save button. The user will need edit permission for the foreign data type.',
                    defaults:
                      '"single_object", "array_ids", "foreign_array_ids" default is "single_object"'
                  },

                  {
                    property: "hide_label",
                    description: "Hides label above item list.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "search_display_primary",
                    description:
                      "Fields displayed in the primary text line of the search results.",
                    defaults: '["text_field1", "text_field2"]'
                  },
                  {
                    property: "search_display_secondary",
                    description:
                      "Fields displayed in the secondary text line of the search results.",
                    defaults: '["text_field1", "text_field2"]'
                  },
                  {
                    property: "search_feilds",
                    description:
                      "Fields tested agaist the free text search. You can use the ^ symbol to increase the weighting of each field.",
                    defaults: '["text_field1^2", "text_field2"]'
                  },
                  {
                    property: "search_icon",
                    description:
                      "Icon choosen from the material icon font displayed agaist the search results.",
                    defaults: '"headset_mic"'
                  },
                  {
                    property: "search_icon_color",
                    description:
                      "	Icon foreground color dispalyed in search results.",
                    defaults: '"#FFFFFF"'
                  },
                  {
                    property: "search_icon_color_background",
                    description:
                      "Icon background color dispalyed in search results.",
                    defaults: '"#1976D2"'
                  },
                  {
                    property: "search_icon_user_avatar",
                    description:
                      'Use the "user" avatar instead of a static icon. The user avatar is a circle with the first inital of "text_first_name" and "text_last_name".',
                    defaults: "true, false default false"
                  }
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Select (Object) Example</h2>
            </section>
            <section>
              <h3>Example 1: Select a user</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_select_object"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"object_my_user"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Assinged User"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"user"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"allow_clear"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_save"</span>: [
                  <span className="jsonY">"text_first_name"</span>,{" "}
                  <span className="jsonY">"text_last_name"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_feilds"</span>: [
                  <span className="jsonY">"text_username^3"</span>,{" "}
                  <span className="jsonY">"text_first_name"</span>,{" "}
                  <span className="jsonY">"text_last_name^2"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_display_primary"</span>: [
                  <span className="jsonY">"text_first_name"</span>,{" "}
                  <span className="jsonY">"text_last_name"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_display_secondary"</span>: [
                  <span className="jsonY">"text_username"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_show_none"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon_user_avatar"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Select an incident</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_select_object"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"object_my_incident"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Connected Incident"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"incident"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"allow_clear"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_save"</span>: [
                  <span className="jsonY">"text_name"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_feilds"</span>: [
                  <span className="jsonY">"text_name"</span>,{" "}
                  <span className="jsonY">"text_description"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_display_primary"</span>: [
                  <span className="jsonY">"text_name"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_display_secondary"</span>: [
                  <span className="jsonY">"text_description"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"search_show_none"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_select_object;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_select_object.js